import { useEffect, type ReactNode } from 'react';
import { MarketingFooter, MarketingHeader } from './MarketingChrome';
import { ResourceSidebar } from './ResourceSidebar';
import './landing.css';
import '../pages/getting-started.css';

type GuideSection = readonly [id: string, title: string];

export function LinkGuideLayout({
  path,
  title,
  lead,
  sections,
  children,
}: {
  path: string;
  title: string;
  lead: string;
  sections: readonly GuideSection[];
  children: ReactNode;
}) {
  useEffect(() => {
    document.title = `${title} | Paddiq`;
  }, [title]);
  return (
    <div className="landing marketing-home mh-interior paddiq-link-guide">
      <a className="mh-skip" href="#main">
        Skip to content
      </a>
      <MarketingHeader />
      <main id="main">
        <section className="guide-hero">
          <div className="landing-container guide-hero__inner">
            <p className="section-kicker">Paddiq Link</p>
            <h1>{title}.</h1>
            <p className="guide-hero__lead">{lead}</p>
            <p>
              See <a href="/paddiq-link">Paddiq Link availability and downloads</a> for the current
              release. This guide applies to builds with the features described below. If a control
              is absent, follow your installed version’s instructions or{' '}
              <a href="/support">contact support</a>.
            </p>
          </div>
        </section>
        <section className="guide-section">
          <div className="landing-container guide-layout">
            <aside className="guide-summary" aria-label="Guide summary">
              <ResourceSidebar currentPath={path} />
              <p className="guide-summary__label">In this guide</p>
              <ol>
                {sections.map(([id, label]) => (
                  <li key={id}>
                    <a href={`#${id}`}>{label}</a>
                  </li>
                ))}
              </ol>
            </aside>
            <article className="guide-content">{children}</article>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </div>
  );
}
